module.exports = __webpack_public_path__ + "static/coffee-02-min-4e88a04dc43ad3ba6152a2d63ac22743.jpg";